export const articles = [
  {
    id: 'acheter-israël-etranger',
    slug: 'acheter-immobilier-israel-etranger',
    title: "Acheter un bien immobilier en Israël en tant qu'étranger",
    subtitle: "Tout ce qu'il faut savoir avant de signer",
    category: 'Guide pratique',
    readTime: 8,
    date: '2024-11-15',
    coverImage: 'contract',
    excerpt: "L'accès à la propriété en Israël est ouvert aux étrangers non-résidents, sans restriction particulière. Cependant, la procédure diffère sensiblement d'un achat en France ou en Belgique.",
    content: [
      {
        type: 'h2',
        text: "Les étrangers peuvent-ils acheter en Israël ?",
      },
      {
        type: 'p',
        text: "Oui, sans restriction. La loi israélienne autorise les ressortissants étrangers à acquérir un bien immobilier en Israël, qu'ils soient juifs ou non. Il n'existe pas de quota ni de délai d'attente lié à la nationalité.",
      },
      {
        type: 'h2',
        text: "Les étapes clés d'un achat",
      },
      {
        type: 'p',
        text: "1. Signature d'un compromis (Hozeh Rechisha) avec un avocat israélien — obligatoire. L'avocat vérifie le titre de propriété (Tabu ou Minhal). 2. Versement d'un acompte de 10 à 30 %. 3. Paiement de la taxe d'achat (Mas Rechisha). 4. Signature de l'acte définitif et inscription au registre foncier (Tabu).",
      },
      {
        type: 'h2',
        text: "La taxe d'achat (Mas Rechisha)",
      },
      {
        type: 'p',
        text: "Pour un non-résident achetant un bien résidentiel, le taux est de 8 % jusqu'à environ 5,35 M₪ (seuil révisé annuellement par l'administration fiscale israélienne) et 10 % au-delà. Les olim (nouveaux immigrants) bénéficient d'un taux préférentiel à 0,5 % sur leur premier logement sous conditions, pendant la première année suivant l'aliyah.",
      },
      {
        type: 'h2',
        text: "Financement et prêt bancaire",
      },
      {
        type: 'p',
        text: "Les banques israéliennes (Hapoalim, Leumi, Discount) peuvent accorder des prêts aux non-résidents, mais avec un apport minimum de 50 % (contre 25 % pour les résidents). Les taux sont indexés sur le shekel et généralement entre 4 et 6 %.",
      },
      {
        type: 'insight',
        text: "Conseil : Prévoyez un budget avocat de 1 à 1,5 % du prix d'achat. L'avocat est indispensable et protège vos intérêts — ne le négligez pas.",
      },
    ],
  },
  {
    id: 'fiscalite-investissement-israel',
    slug: 'fiscalite-investissement-immobilier-israel',
    title: 'Fiscalité immobilière en Israël pour les non-résidents',
    subtitle: "Taxes d'achat, impôt sur les loyers, plus-values",
    category: 'Fiscalité',
    readTime: 10,
    date: '2024-10-28',
    coverImage: 'consultation',
    excerpt: "La fiscalité israélienne réserve des règles spécifiques aux investisseurs non-résidents. Comprendre ces mécanismes est indispensable avant tout investissement.",
    content: [
      {
        type: 'h2',
        text: "Taxe d'achat (Mas Rechisha)",
      },
      {
        type: 'p',
        text: "Non-résidents : 8 % de la première à la dernière unité jusqu'à environ 5,35 M₪ (seuil révisé annuellement), puis 10 % au-delà. Résidents achetant leur résidence principale : 0 % jusqu'à environ 1,97 M₪ (seuil 2024-2025). Cette taxe est payée lors de la signature du contrat définitif.",
      },
      {
        type: 'h2',
        text: "Impôt sur les revenus locatifs",
      },
      {
        type: 'p',
        text: "Deux régimes existent : le régime forfaitaire à 15 % sur le loyer brut (simple, sans déduction de charges) ou le régime réel avec déduction des charges réelles et imposition au taux marginal (jusqu'à 50 %). Pour les petits revenus, le forfait à 15 % est souvent plus avantageux.",
      },
      {
        type: 'h2',
        text: "Plus-value immobilière (Mas Shevach)",
      },
      {
        type: 'p',
        text: "Le taux standard est de 25 % sur la plus-value nette. Des exemptions partielles existent en fonction de la durée de détention et du statut du vendeur. Un avocat fiscaliste israélien peut optimiser ce point.",
      },
      {
        type: 'insight',
        text: "Important : Israël a signé des conventions fiscales avec la France, la Belgique et la Suisse pour éviter la double imposition. Votre conseiller fiscal français doit coordonner avec un avocat fiscal israélien.",
      },
    ],
  },
  {
    id: 'quartiers-tel-aviv-investissement',
    slug: 'meilleurs-quartiers-tel-aviv-investissement',
    title: 'Les meilleurs quartiers de Tel Aviv pour investir en 2025',
    subtitle: 'Neve Tzedek, Florentin, Jaffa : analyse comparée',
    category: 'Analyse de marché',
    readTime: 7,
    date: '2024-12-01',
    coverImage: 'tel-aviv-beach',
    excerpt: "Tel Aviv est une ville de microclimats immobiliers. Le même budget peut donner des résultats très différents selon le quartier choisi. Voici notre analyse.",
    content: [
      {
        type: 'h2',
        text: "Neve Tzedek — La valeur sûre ultra-premium",
      },
      {
        type: 'p',
        text: "Premier quartier résidentiel de Tel Aviv (1887), Neve Tzedek est l'équivalent du Marais parisien. Rues pavées, maisons ottomanes rénovées, galeries d'art. Prix : 100 000–120 000 ₪/m². Rendement locatif classique : 1,8–2,1 %. Idéal pour la préservation du capital.",
      },
      {
        type: 'h2',
        text: "Florentin — Le quartier du rendement",
      },
      {
        type: 'p',
        text: "Quartier bohème en pleine gentrification, Florentin offre le meilleur compromis prix/rendement dans Tel Aviv. Prix : 75 000–90 000 ₪/m². Rendement : 2,5–3 %. Très actif sur Airbnb. À surveiller : la réglementation Airbnb peut évoluer.",
      },
      {
        type: 'h2',
        text: "Jaffa (Yafo) — La pépite en transformation",
      },
      {
        type: 'p',
        text: "Ancienne ville arabe intégrée à Tel Aviv, Jaffa est en pleine gentrification depuis 10 ans. Les prix ont doublé mais restent 20–30 % sous Neve Tzedek. Fort potentiel touristique (vieille ville classée). Rendement Airbnb : 6–9 %.",
      },
      {
        type: 'insight',
        text: "Notre recommandation : Pour un budget < 2 M₪, privilégiez Florentin ou Jaffa Sud. Pour > 4 M₪, Neve Tzedek ou Rothschild restent les valeurs les plus sûres à long terme.",
      },
    ],
  },
  {
    id: 'strategie-airbnb-israel',
    coverImage: 'sea-view-balcony',
    slug: 'strategie-airbnb-investissement-israel',
    title: "Location courte durée en Israël : tout ce qu'il faut savoir",
    subtitle: 'Réglementation, rendements réels, villes à privilégier',
    category: 'Stratégie',
    readTime: 6,
    date: '2024-09-20',
    excerpt: "L'Airbnb israélien est l'un des plus rentables de la région. Mais il faut connaître les règles avant de se lancer.",
    content: [
      {
        type: 'h2',
        text: "La réglementation actuelle",
      },
      {
        type: 'p',
        text: "En 2024, Israël n'a pas encore de loi nationale encadrant strictement la location courte durée. Certaines municipalités (Tel Aviv notamment) ont imposé une déclaration obligatoire. La situation évolue — à surveiller.",
      },
      {
        type: 'h2',
        text: "Les villes les plus rentables",
      },
      {
        type: 'p',
        text: "Eilat : taux d'occupation 76 %, tarif moyen 580 ₪/nuit. Tel Aviv (centre) : 72 %, 650 ₪/nuit. Jérusalem (vieille ville) : 65 %, 480 ₪/nuit. Ces chiffres sont des moyennes annualisées.",
      },
      {
        type: 'h2',
        text: "Les coûts à anticiper",
      },
      {
        type: 'p',
        text: "Gestion locative : 20–25 % du CA. Ménage : 150–250 ₪/rotation. Maintenance : 3–5 % du CA annuel. Assurance : 2 000–4 000 ₪/an. Net après charges : comptez 60–70 % du CA Airbnb brut.",
      },
      {
        type: 'insight',
        text: "Pour une gestion sereine depuis la France, budgétez une conciergerie locale à 20 % minimum. Le net reste très attractif comparé à la location longue durée.",
      },
    ],
  },
  {
    id: 'arnona-taxe-fonciere',
    coverImage: 'interior-kitchen',
    slug: 'arnona-taxe-fonciere-israel',
    title: "L'Arnona : la taxe foncière israélienne expliquée",
    subtitle: 'Calcul, montants, exemptions pour non-résidents',
    category: 'Fiscalité',
    readTime: 5,
    date: '2024-08-14',
    excerpt: "L'Arnona est la taxe municipale israélienne payée par l'occupant du bien. Son montant varie fortement selon la ville et la surface.",
    content: [
      {
        type: 'h2',
        text: "Qu'est-ce que l'Arnona ?",
      },
      {
        type: 'p',
        text: "L'Arnona est une taxe municipale annuelle payée par l'occupant du bien (locataire ou propriétaire occupant). Elle finance les services municipaux. En cas de location, c'est généralement le locataire qui la paie.",
      },
      {
        type: 'h2',
        text: "Montants indicatifs par ville",
      },
      {
        type: 'p',
        text: "Tel Aviv : 120–180 ₪/m²/an. Jérusalem : 90–140 ₪/m²/an. Haïfa : 70–110 ₪/m²/an. Beer Sheva : 50–80 ₪/m²/an. Pour un appartement de 60 m² à Tel Aviv, comptez 7 200–10 800 ₪/an.",
      },
      {
        type: 'h2',
        text: "Qui paie l'Arnona ?",
      },
      {
        type: 'p',
        text: "En location longue durée : le locataire. En location courte durée (Airbnb) : le propriétaire. Logement vacant : le propriétaire paie généralement 50 % du tarif, pendant 1 an au maximum.",
      },
      {
        type: 'insight',
        text: "Attention : pour un bien Airbnb ou vacant, l'Arnona est à votre charge. Intégrez-la dans votre calcul de rendement net.",
      },
    ],
  },
  {
    id: 'marche-immobilier-israel-2025',
    coverImage: 'tel-aviv-beach',
    slug: 'marche-immobilier-israel-2025-bilan',
    title: "Marché immobilier israélien en 2025 : bilan complet",
    subtitle: "Prix, volumes, tendances et ce qui a vraiment changé",
    category: 'Analyse de marché',
    readTime: 9,
    date: '2025-02-10',
    excerpt: "Après deux années de consolidation post-COVID et un contexte géopolitique incertain, le marché immobilier israélien en 2025 montre des signaux de reprise clairs. Voici ce que les chiffres disent vraiment.",
    content: [
      {
        type: 'h2',
        text: "2025 : un marché en correction, mais avec de fortes disparités",
      },
      {
        type: 'p',
        text: "Contrairement aux années post-COVID marquées par des hausses généralisées, le marché immobilier israélien en 2025 présente un tableau contrasté. Selon les données Q3 2025 du Bureau central des statistiques israélien (CBS), les prix reculent dans plusieurs grandes villes tout en progressant fortement dans d'autres. Le volume de transactions reste soutenu par la demande diaspora et les besoins structurels d'une population en croissance. Les investisseurs avisés trouvent des opportunités précisément dans cette divergence.",
      },
      {
        type: 'h2',
        text: "Les prix au m² en 2025 : ville par ville",
      },
      {
        type: 'p',
        text: "Tel Aviv reste la ville la plus chère à 70 000 ₪/m² en moyenne, mais en correction de –2,8 % sur 12 mois (Q3 2025) — une opportunité pour les acheteurs. Jérusalem affiche la meilleure performance nationale avec +9,4 % sur 12 mois, à 46 000 ₪/m², portée par une demande diaspora record. Haïfa se stabilise à 24 000 ₪/m² (+0,5 %), marché le plus prévisible d'Israël. Netanya à 28 000 ₪/m², Ashdod en correction marquée (–7,97 %). Beer Sheva reste le plus accessible à 15 000 ₪/m², avec une croissance annuelle régulière de +2,1 %.",
      },
      {
        type: 'h2',
        text: "La diaspora francophone : moteur résilient",
      },
      {
        type: 'p',
        text: "Les investisseurs francophones (France, Belgique, Suisse, Canada, Maroc) représentent une part croissante des transactions sur les marchés de Netanya, Jérusalem et Tel Aviv. En 2025, les achats par des non-résidents s'établissent autour de 12 % du total — un niveau stable mais significatif. Le rééquilibrage euro/shekel de 2025 a relancé les projets mis en attente depuis 2023–2024, notamment pour les investisseurs européens ciblant Jérusalem et Netanya.",
      },
      {
        type: 'h2',
        text: "Les marchés contrastés à surveiller",
      },
      {
        type: 'p',
        text: "À Tel Aviv, les biens nécessitant rénovation dans Florentin et Jaffa présentent des décotes de 10–15 % sur le marché en correction — fenêtre d'opportunité pour les acheteurs actifs. À Jérusalem, les quartiers Baka et Katamon offrent un rapport qualité/prix supérieur à Rechavia (prix 20–30 % inférieurs pour un profil locatif similaire). Ashdod, en recul de –7,97 %, constitue un point d'entrée potentiel pour les investisseurs contrariants avec horizon 5 ans+.",
      },
      {
        type: 'insight',
        text: "Sources : CBS Israël Q3 2025, GlobalPropertyGuide 2025, Airbtics 2025, Tabu (registre foncier israélien). Ces données sont indicatives — consultez un professionnel avant tout investissement.",
      },
    ],
  },
  {
    id: 'previsions-immobilier-israel-2026',
    coverImage: 'tel-aviv-modern',
    slug: 'previsions-immobilier-israel-2026',
    title: "Immobilier en Israël : nos prévisions pour 2026",
    subtitle: "Hausse des prix, nouvelles opportunités, risques à surveiller",
    category: 'Analyse de marché',
    readTime: 8,
    date: '2025-03-01',
    excerpt: "Que va-t-il se passer sur le marché immobilier israélien en 2026 ? Taux d'intérêt, démographie, tensions géopolitiques : voici notre analyse prospective.",
    content: [
      {
        type: 'h2',
        text: "Scénario central : une hausse modérée des prix",
      },
      {
        type: 'p',
        text: "Notre scénario central pour 2026 table sur une stabilisation puis reprise modérée des prix (+3 à +6 % au niveau national), après la correction de 2025. Trois facteurs structurels soutiennent ce scénario : (1) une demande démographique qui dépasse l'offre — Israël construit environ 60 000 logements par an pour une population qui croît de 150 000 personnes ; (2) une baisse probable des taux directeurs de la Banque d'Israël vers 3,5–4 % en 2026, ce qui stimulera le crédit immobilier ; (3) un retour progressif des investisseurs diaspora, qui ont mis leurs projets en attente pendant la correction.",
      },
      {
        type: 'h2',
        text: "Les villes à surveiller en 2026",
      },
      {
        type: 'p',
        text: "Haïfa est notre top pick pour 2026. La ville bénéficie d'une combinaison rare : prix raisonnables (24 000 ₪/m² en moyenne, soit –66 % par rapport à Tel Aviv), fort dynamisme tech avec le Technion et Intel, et projets d'infrastructure (ligne de métro léger Carmelit 2.0). Marché stable en 2025 (+0,5 %) — base solide pour une appréciation en 2026. Beer Sheva constitue le pari le plus asymétrique : si le développement du parc cybersécurité CyberSpark (IBM, Oracle, Deutsche Telekom) se confirme, les prix pourraient bondir de 10–15 % sur 24 mois. Tickets accessibles dès 450 000 ₪.",
      },
      {
        type: 'h2',
        text: "Tel Aviv : consolidation avant une nouvelle vague",
      },
      {
        type: 'p',
        text: "Tel Aviv a connu une correction de –2,8 % sur 12 mois (Q3 2025). En 2026, nous anticipons une stabilisation puis une légère reprise (+2–4 %). Les rendements locatifs s'améliorent mécaniquement grâce à la baisse des prix et à la hausse des loyers (+6 % en 2025). L'intérêt principal de Tel Aviv reste patrimonial : la ville est la plus liquide d'Israël à la revente et démontre une résilience structurelle sur le long terme. La correction actuelle est une fenêtre d'achat pour les investisseurs patrimoniaux.",
      },
      {
        type: 'h2',
        text: "Les risques à surveiller",
      },
      {
        type: 'p',
        text: "Trois risques principaux pèsent sur ce scénario optimiste. (1) Un rebond des tensions géopolitiques régionales pourrait geler les transactions des non-résidents, comme observé fin 2023. (2) Une remontée inattendue de l'inflation israélienne (actuellement autour de 3 %) pourrait retarder les baisses de taux. (3) Une réforme de la taxe d'achat pour les non-résidents est régulièrement évoquée dans les débats politiques — si elle était adoptée, elle renchérirait le coût d'entrée pour les investisseurs étrangers.",
      },
      {
        type: 'insight',
        text: "Notre recommandation 2026 : Jérusalem pour la performance (+9,4 % en 2025, momentum fort), Haïfa pour le rendement stable et prévisible, Beer Sheva pour le potentiel de plus-value, Tel Aviv pour la préservation patrimoniale en profitant de la correction actuelle. Diversifier entre deux villes reste la meilleure stratégie pour un budget de 1–2 M₪.",
      },
    ],
  },
  {
    id: 'haifa-vs-netanya-2025',
    coverImage: 'haifa-real',
    slug: 'haifa-vs-netanya-investir-2025',
    title: "Haïfa vs Netanya : où investir en 2025 ?",
    subtitle: "Comparatif complet : prix, rendements, profils d'investisseurs",
    category: 'Analyse de marché',
    readTime: 7,
    date: '2025-01-20',
    excerpt: "Deux villes, deux stratégies. Haïfa pour le rendement et la croissance, Netanya pour la liquidité et la communauté francophone. On compare tout.",
    content: [
      {
        type: 'h2',
        text: "Les prix en 2025 : un écart significatif",
      },
      {
        type: 'p',
        text: "En 2025, Haïfa affiche une moyenne de 24 000 ₪/m² contre 28 000 ₪/m² à Netanya — soit un écart d'environ 14 %. Pour un 2 pièces de 60 m², cela représente une différence d'entrée de 240 000 ₪ (environ 60 000 €). Haïfa reste plus accessible, surtout dans les quartiers du Hadar et de Neve Sha'anan. Les deux villes sont bien en dessous de Tel Aviv (70 000 ₪/m²).",
      },
      {
        type: 'h2',
        text: "Rendements locatifs : avantage Haïfa",
      },
      {
        type: 'p',
        text: "Haïfa : rendement brut moyen de 3,4–3,9 % en 2025, porté par une forte demande étudiante (Technion, Université de Haïfa) et des prix d'achat maîtrisés. Marché le plus prévisible d'Israël, prix stables à +0,5 % sur 12 mois. Netanya : rendement brut de 3,6–3,9 %, avec un marché Airbnb dynamique — revenus annuels estimés à 116 536 ₪ (50 % d'occupation, Airbtics 2025). Les deux villes offrent une bonne liquidité à la revente.",
      },
      {
        type: 'h2',
        text: "La carte communautaire : Netanya imbattable",
      },
      {
        type: 'p',
        text: "Netanya compte 35 000–40 000 francophones, soit la plus grande concentration en dehors de Tel Aviv. Cela se traduit concrètement par : des agents immobiliers francophones, des gestionnaires locatifs francophones, une communauté qui facilite la gestion à distance. Pour un investisseur français qui veut gérer son bien sans barrière linguistique, Netanya reste la ville la plus pratique d'Israël.",
      },
      {
        type: 'h2',
        text: "Potentiel de plus-value : avantage Haïfa pour 2026",
      },
      {
        type: 'p',
        text: "Les projets d'infrastructure de Haïfa (ligne de métro léger Carmelit 2.0, expansion d'Intel Haïfa) et son positionnement comme deuxième ville tech d'Israël lui confèrent un potentiel de hausse supérieur à Netanya sur 2026. Haïfa a démontré sa stabilité en 2025 (+0,5 %) — une base solide. Notre estimation pour 2026 : +5–8 % à Haïfa contre +3–5 % à Netanya (portée par la demande bord de mer).",
      },
      {
        type: 'insight',
        text: "Notre verdict : Haïfa pour maximiser le rendement et la plus-value long terme. Netanya pour la simplicité de gestion à distance et la liquidité. Si vous hésitez, votre priorité (rendement ou confort de gestion) doit décider.",
      },
    ],
  },
  {
    id: 'acheter-tel-aviv-2025',
    coverImage: 'tel-aviv-beach',
    slug: 'acheter-appartement-tel-aviv-2025-prix',
    title: "Combien coûte un appartement à Tel Aviv en 2025 ?",
    subtitle: "Prix réels par quartier, frais à prévoir, budget total",
    category: 'Guide pratique',
    readTime: 8,
    date: '2025-02-25',
    excerpt: "Tel Aviv reste la ville la plus chère d'Israël. Mais les prix varient du simple au triple selon le quartier. Voici ce qu'il faut vraiment prévoir en 2025.",
    content: [
      {
        type: 'h2',
        text: "Prix au m² par quartier en 2025",
      },
      {
        type: 'p',
        text: "Les prix varient considérablement selon les quartiers. Les plus chers : Neve Tzedek et Rothschild (100 000–120 000 ₪/m²), le Centre-Ville et Lev Ha'Ir (85 000–100 000 ₪/m²). Les quartiers intermédiaires : Florentin et Kerem HaTeimanim (75 000–90 000 ₪/m²), Old North et Ramat Aviv Gimel (70 000–85 000 ₪/m²). Les quartiers plus accessibles : Jaffa Sud et Givat Amal (55 000–70 000 ₪/m²), Bat Yam (limite sud, 45 000–55 000 ₪/m²).",
      },
      {
        type: 'h2',
        text: "Budgets typiques par type de bien",
      },
      {
        type: 'p',
        text: "Studio (25–35 m²) : de 1,4 M₪ à Jaffa jusqu'à 3,5 M₪ à Neve Tzedek. 2 pièces (50–65 m²) : de 2,8 M₪ (Jaffa) à 6,5 M₪ (Neve Tzedek). 3 pièces (75–90 m²) : de 4 M₪ à 10 M₪ selon le quartier. Ces prix sont des valeurs de marché 2025, hors frais d'acquisition.",
      },
      {
        type: 'h2',
        text: "Les frais à ajouter au prix d'achat",
      },
      {
        type: 'p',
        text: "Pour un non-résident, le budget total dépasse le prix affiché de 10 à 12 %. Détail : Taxe d'achat (Mas Rechisha) : 8 % du prix. Avocat acheteur : 1–1,5 %. Avocat vendeur (parfois partagé) : 0,5 %. Agence immobilière : 2 % (si applicable). Inscription au Tabu : 0,5 %. Soit sur un bien à 3 M₪ : environ 300 000–360 000 ₪ de frais supplémentaires.",
      },
      {
        type: 'h2',
        text: "Financement : ce que les banques israéliennes acceptent en 2025",
      },
      {
        type: 'p',
        text: "En 2025, les banques israéliennes (Hapoalim, Leumi, Mizrahi Tefahot) accordent des prêts aux non-résidents avec un apport minimum de 50 %. Les taux varient entre 4 et 5,5 % selon la durée et le profil. Un courtier spécialisé en financement non-résident peut obtenir de meilleures conditions qu'en allant directement en agence.",
      },
      {
        type: 'insight',
        text: "Règle d'or : ajoutez toujours 10–12 % au prix affiché pour calculer votre investissement total. Un bien à 3 M₪ vous coûtera réellement 3,3–3,36 M₪ tout compris.",
      },
    ],
  },
  {
    id: 'beer-sheva-opportunite-2025',
    coverImage: 'negev-desert',
    slug: 'investir-beer-sheva-opportunite-2025',
    title: "Beer Sheva 2025 : le deal immobilier qu'on ne voit pas venir",
    subtitle: "Rendements à 6 %, tickets accessibles, potentiel de hausse — décryptage",
    category: 'Stratégie',
    readTime: 6,
    date: '2025-03-10',
    excerpt: "Beer Sheva est la ville la moins sexy d'Israël. C'est précisément pour ça que c'est peut-être le meilleur deal du marché en 2025. Analyse.",
    content: [
      {
        type: 'h2',
        text: "Les chiffres qui font réfléchir",
      },
      {
        type: 'p',
        text: "Beer Sheva en 2025 : prix moyen à 15 000 ₪/m², rendement brut de 4,8–5,5 %, loyer d'un studio à 2 200 ₪/mois pour un prix d'achat à 480 000 ₪. À titre de comparaison, un studio équivalent à Tel Aviv coûte 2,4 M₪ pour un loyer de 6 500 ₪/mois — soit un rendement brut de 3,25 %. Beer Sheva offre un rendement 60 % supérieur pour un ticket 5 fois moins élevé. La croissance annuelle de +2,1 % est la plus régulière d'Israël (GlobalPropertyGuide 2025).",
      },
      {
        type: 'h2',
        text: "Pourquoi Beer Sheva est en train de changer",
      },
      {
        type: 'p',
        text: "Plusieurs tendances de fond soutiennent Beer Sheva en 2025–2026. L'Université Ben Gourion du Néguev compte aujourd'hui 20 000 étudiants et continue de croître. Le gouvernement israélien a officialisé la création d'un parc national de cybersécurité (CyberSpark) qui attire déjà IBM, Oracle, Deutsche Telekom. L'armée israélienne (Tsahal) a massivement relocalisé ses bases administratives dans le Néguev, amenant des milliers de familles dans la région. Ces éléments structurels soutiennent une demande locative croissante.",
      },
      {
        type: 'h2',
        text: "Les quartiers où investir à Beer Sheva",
      },
      {
        type: 'p',
        text: "Guivat Tzarfatit (le quartier français) : communauté francophone établie, demande locative stable, prix : 16 000–20 000 ₪/m². Neve Ze'ev : quartier résidentiel moderne, proche du campus BGU, idéal pour la location étudiante. Old City (Vieille ville) : projet de réhabilitation urbaine en cours — pari sur la valorisation à 5–7 ans, prix très accessibles sous 15 000 ₪/m².",
      },
      {
        type: 'h2',
        text: "Les risques à ne pas ignorer",
      },
      {
        type: 'p',
        text: "Beer Sheva n'est pas sans risques. La liquidité à la revente est inférieure à Tel Aviv ou Haïfa. La ville est géographiquement proche de Gaza, ce qui peut impacter la confiance des acheteurs lors des périodes de tension. Enfin, le scénario de valorisation dépend de la réalisation effective des projets tech et militaires — si ces catalyseurs se concrétisent moins vite que prévu, la plus-value sera limitée.",
      },
      {
        type: 'insight',
        text: "Notre verdict : Beer Sheva est le meilleur deal rendement/prix du marché israélien en 2025. Idéal pour un premier investissement en Israël ou pour diversifier un portefeuille immobilier déjà positionné sur Tel Aviv. Budget minimum recommandé : 480 000–700 000 ₪ (120 000–175 000 €). La croissance la plus stable d'Israël (+2,1 %/an) en fait un investissement prévisible à horizon 5–7 ans.",
      },
    ],
  },
  {
    id: 'questions-fiscales-lecteurs-1',
    slug: 'questions-fiscales-investisseurs-israel-2025',
    title: "Vos questions fiscales sur l'immobilier israélien — nos réponses",
    subtitle: "Benjamin, Nathan, Sarah… ils ont posé les vraies questions",
    category: 'Fiscalité',
    readTime: 7,
    date: '2025-03-05',
    coverImage: 'consultation',
    excerpt: "Taxes d'achat, double imposition, déclaration en France, impôt sur les loyers… Nos lecteurs posent les questions que tout investisseur francophone se pose. Voici nos réponses.",
    content: [
      { type: 'p', text: "Chaque semaine, des investisseurs francophones nous contactent avec des questions précises sur la fiscalité israélienne. Voici une sélection des questions les plus fréquentes, avec nos réponses détaillées." },
      { type: 'photo', src: 'consultation', caption: 'Chaque projet d\'investissement mérite une analyse fiscale personnalisée.' },
      { type: 'qa', name: 'Benjamin M.', origin: 'Paris, France', question: "J'ai entendu dire que la taxe d'achat en Israël est de 8 %. C'est vraiment ça ? Et est-ce que ça s'applique dès le premier euro ?", answer: "Oui, pour un non-résident achetant un bien résidentiel en Israël, le taux est de 8 % jusqu'à environ 5,35 millions de shekels (seuil révisé annuellement par l'administration fiscale israélienne) et 10 % au-delà. Ce taux s'applique dès le premier shekel — il n'y a pas de tranche à 0 % comme pour les résidents primo-accédants. Sur un bien à 1,5 M₪ (environ 375 000 €), vous paierez donc 120 000 ₪ de taxe d'achat. À intégrer absolument dans votre budget." },
      { type: 'qa', name: 'Nathan K.', origin: 'Bruxelles, Belgique', question: "Je suis Belge, je veux acheter un appartement à Haïfa pour le louer. Est-ce que je dois déclarer les loyers en Belgique et en Israël ? Comment éviter la double imposition ?", answer: "Bonne question. La Belgique et Israël ont signé une convention fiscale de non-double imposition. En pratique : vous déclarez vos revenus locatifs israéliens en Israël (au taux forfaitaire de 15 % ou au régime réel), puis vous les déclarez aussi en Belgique, mais la Belgique vous accorde un crédit d'impôt équivalent à ce que vous avez déjà payé en Israël. Vous ne payez pas deux fois — mais vous devez faire les deux déclarations. Nous recommandons fortement de consulter un comptable spécialisé en fiscalité internationale." },
      { type: 'qa', name: 'Sarah L.', origin: 'Lyon, France', question: "Si je revends mon appartement dans 5 ans avec une plus-value, combien vais-je payer en impôts en Israël ?", answer: "En Israël, la plus-value immobilière (Mas Shevach) est taxée à 25 % sur le gain net pour les non-résidents. Des abattements peuvent s'appliquer selon la durée de détention et l'usage du bien. Par exemple, si vous achetez un bien à 1,5 M₪ et le revendez à 2 M₪, votre plus-value brute est de 500 000 ₪. Après déduction des frais d'acquisition, de rénovation et de l'inflation officielle, la base taxable sera inférieure. Un avocat fiscaliste israélien peut optimiser significativement ce poste — ce n'est pas optionnel." },
      { type: 'qa', name: 'David C.', origin: 'Montréal, Canada', question: "Je suis de nationalité canadienne mais je veux faire mon aliyah dans 2 ans. Est-ce que je devrais acheter maintenant comme non-résident ou attendre mon aliyah pour bénéficier des avantages fiscaux ?", answer: "C'est une question stratégique importante. Les olim (nouveaux immigrants) bénéficient d'un taux de taxe d'achat réduit à 0 % jusqu'à 1,97 M₪ sur leur premier logement, pendant la première année suivant l'aliyah. Si votre budget est inférieur à ce seuil, attendre votre aliyah vous ferait économiser 8 % du prix d'achat — une somme considérable. Au-delà, l'avantage s'amenuise. Si vous avez un budget de 2 M₪+, l'écart fiscal est moins décisif et d'autres considérations (timing du marché, disponibilité du bien) peuvent primer." },
      { type: 'insight', text: "Ces réponses sont données à titre informatif. La situation fiscale de chaque investisseur est unique. Consultez un avocat fiscaliste israélien et votre conseiller fiscal dans votre pays de résidence avant toute décision." },
    ],
  },
  {
    id: 'questions-pratiques-lecteurs-2',
    slug: 'questions-pratiques-achat-israel-2025',
    title: "Vos questions pratiques sur l'achat en Israël — nos réponses",
    subtitle: "Victor, Jonathan, Rachel… les vraies questions avant de se lancer",
    category: 'Guide pratique',
    readTime: 8,
    date: '2025-03-12',
    coverImage: 'contract',
    excerpt: "Financement, avocat, gestion à distance, visa… Nos lecteurs posent les questions concrètes qui bloquent les projets. Voici ce qu'il faut vraiment savoir.",
    content: [
      { type: 'p', text: "Avant de se lancer dans un achat immobilier en Israël, les mêmes questions reviennent. Budget, financement, gestion à distance, risques… Voici les questions les plus posées par nos lecteurs en 2025." },
      { type: 'photo', src: 'contract', caption: 'La signature d\'un compromis en Israël (Hozeh Rechisha) doit toujours être accompagnée d\'un avocat.' },
      { type: 'qa', name: 'Victor A.', origin: 'Nice, France', question: "J'ai 200 000 € d'apport. Est-ce que c'est suffisant pour investir en Israël ? Dans quelle ville ?", answer: "200 000 € représentent environ 800 000 ₪. Avec un apport minimum de 50 % requis par les banques israéliennes pour les non-résidents, vous pouvez viser un bien jusqu'à 1,6 M₪ (environ 400 000 €). Cela correspond à un studio confortable à Haïfa ou Beer Sheva, ou un petit studio en périphérie de Tel Aviv. Notre recommandation avec ce budget : Beer Sheva ou Haïfa pour le rendement, ou Netanya pour la facilité de gestion (forte communauté francophone). Évitez de vous étirer sur Tel Aviv avec ce budget — les rendements y sont trop faibles." },
      { type: 'qa', name: 'Jonathan B.', origin: 'Genève, Suisse', question: "Est-ce qu'on a vraiment besoin d'un avocat pour acheter en Israël ? Je veux dire, est-ce obligatoire ou juste conseillé ?", answer: "En Israël, l'avocat n'est pas légalement obligatoire mais il est absolument indispensable en pratique. Le compromis (Hozeh Rechisha) est un document juridique complexe qui engage vos droits de façon irréversible. L'avocat vérifie le titre de propriété au Tabu (registre foncier), s'assure qu'il n'y a pas d'hypothèques cachées, protège votre acompte, et gère les étapes administratives. Son coût est de 1 à 1,5 % du prix d'achat — c'est l'investissement le plus rentable de tout votre projet." },
      { type: 'photo', src: 'interior-living', caption: 'Un appartement bien situé à Haïfa peut offrir un rendement brut de 4 à 4,5 % en 2025.' },
      { type: 'qa', name: 'Rachel M.', origin: 'Paris, France', question: "Je ne parle pas hébreu. Comment je gère mon bien à distance depuis la France ? C'est vraiment faisable ?", answer: "Oui, c'est tout à fait faisable — des centaines d'investisseurs francophones le font. La clé : choisir une société de gestion locative francophone ou anglophone (il en existe de sérieuses à Tel Aviv, Netanya, Haïfa) qui s'occupe de tout : trouver les locataires, encaisser les loyers, gérer les réparations. Comptez 8 à 12 % du loyer mensuel pour une gestion complète. Netanya est la ville idéale pour ce profil — la communauté francophone dense facilite énormément la gestion à distance." },
      { type: 'qa', name: 'Raphael D.', origin: 'Casablanca, Maroc', question: "En tant que ressortissant marocain, est-ce que j'ai le droit d'acheter en Israël depuis la normalisation des relations ?", answer: "Depuis les Accords d'Abraham (2020), les ressortissants marocains peuvent en principe acheter des biens immobiliers en Israël, comme tout étranger. La loi israélienne n'impose pas de restriction par nationalité. En pratique, les démarches bancaires peuvent nécessiter quelques vérifications supplémentaires. Nous recommandons de consulter un avocat israélien spécialisé pour vous assurer que votre situation personnelle ne présente pas de complications spécifiques." },
      { type: 'insight', text: "Vous avez une question spécifique sur votre projet ? Utilisez notre formulaire de contact — nous répondons sous 48h." },
    ],
  },
  {
    id: 'questions-marche-lecteurs-3',
    slug: 'questions-marche-immobilier-israel-opportunites-2025',
    title: "Deal, opportunité ou piège ? Vos questions sur le marché israélien",
    subtitle: "Nos lecteurs analysent des cas réels — on répond franchement",
    category: 'Analyse de marché',
    readTime: 7,
    date: '2025-03-18',
    coverImage: 'jerusalem-real',
    excerpt: "Tel Aviv trop cher ? Beer Sheva trop risqué ? Eilat vraiment rentable ? Nos lecteurs soumettent leurs cas concrets et on répond sans langue de bois.",
    content: [
      { type: 'p', text: "Chaque mois, nos lecteurs nous partagent des opportunités qu'ils ont repérées ou des doutes sur des marchés spécifiques. Voici une sélection de cas concrets avec notre analyse franche." },
      { type: 'photo', src: 'city-aerial', caption: 'Vue aérienne d\'une grande métropole — chaque marché a ses logiques propres.' },
      { type: 'qa', name: 'Yohan S.', origin: 'Strasbourg, France', question: "J'ai vu un appartement à Eilat, 900 000 ₪, avec une agence qui me promet 8 % de rendement Airbnb. C'est réaliste ou c'est du baratin ?", answer: "La prudence s'impose. 8 % brut Airbnb à Eilat est dans la fourchette haute du possible, pas impossible, mais rarement garanti sur l'année entière. Eilat est très saisonnier — les mois d'été et les fêtes juives sont excellents, mais les creux peuvent être profonds. Nos données 2025 indiquent une moyenne de 6–7 % brut annualisé pour les biens bien situés (proche de la plage, bonne gestion). Après charges de gestion (20–25 %), ménage et maintenance, le net tourne plutôt autour de 4,5–5,5 %. Vérifiez l'historique réel du taux d'occupation avant de signer." },
      { type: 'qa', name: 'Elias B.', origin: 'Toulouse, France', question: "On m'a dit que Jérusalem c'est risqué à cause de la géopolitique. Mais les prix n'ont pas l'air d'avoir baissé. Comment vous expliquez ça ?", answer: "Vous avez raison — les prix à Jérusalem ont montré une résilience remarquable malgré les tensions récurrentes. L'explication est structurelle : la demande diaspora pour Jérusalem est quasi-indépendante de la conjoncture sécuritaire. Pour de nombreux acheteurs juifs du monde entier, avoir un pied-à-terre à Jérusalem relève d'une décision patrimoniale et identitaire, pas purement financière. Ce soutien de la demande 'de conviction' stabilise le marché même en période de tensions. Le risque existe, mais il est partiellement compensé par cette demande structurelle." },
      { type: 'photo', src: 'jerusalem', caption: 'Jérusalem affiche une résilience des prix portée par la forte demande diaspora mondiale.' },
      { type: 'qa', name: 'Simon F.', origin: 'Paris, France', question: "J'hésite entre acheter un 3 pièces à Beer Sheva pour 1,1 M₪ ou deux studios à Haïfa pour le même budget. Qu'est-ce qui est plus intelligent ?", answer: "Question excellente. Les deux stratégies sont valides mais avec des profils différents. Un 3 pièces à Beer Sheva : loyer potentiel de 5 000 ₪/mois, rendement brut ~5,5 %, mais un seul locataire — si le logement est vide, vous avez 0 revenu. Deux studios à Haïfa : chacun à ~550 000 ₪, loyer ~3 200 ₪/mois chacun, soit 6 400 ₪ total, rendement ~7 % global. Avantage : si un studio est vide, l'autre continue de rapporter. Inconvénient : deux gestions, deux syndics, deux assurances. Pour un investisseur à distance, les deux studios offrent plus de sécurité. Pour quelqu'un qui veut simplifier, le 3 pièces est plus facile à gérer." },
      { type: 'insight', text: "Vous analysez une opportunité spécifique ? Envoyez-nous les détails via notre formulaire — on vous donne notre avis sous 48h." },
    ],
  },
];

export const getArticleBySlug = (slug) => articles.find(a => a.slug === slug);
export const getArticlesByCategory = (cat) => articles.filter(a => a.category === cat);
export const categories = [...new Set(articles.map(a => a.category))];
